module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-fraternity-c62ab9e6648311aa5503fe961f458aab.jpg";